'use client'
import moment from "moment";
import React, {useEffect, useState} from 'react';
import {
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ComposedChart, Area, ReferenceLine,
} from 'recharts';
import {useSearchParams} from "react-router-dom";

const dateFormatter = date => {
    return moment(date).format('DD-MM-YYYY');
};

const ReferenceLabel = (props) => {
  const {
    date,
    viewBox,
  } = props;
  const x = viewBox.x - 90;
  const y = window.innerHeight/2 - 65;
  return (
    <foreignObject x={x} y={y} width="80" height="50">
      <div xmlns="http://www.w3.org/1999/xhtml" style={{color:"red"}}>
          OK Datum<br/>
        <small>
          {date}
        </small>
      </div>
    </foreignObject>
  )
}

// label={{ position: 'right',  value: "a/b", fill: 'red', fontSize: 14 }}

const processData2=(data)=>{
    console.log(data)
    let new_series = [];
    let first_date = null
    let last_date = null
    let okdatum = null

    if(data===undefined)
        return [];

    if(data.series===undefined)
        return [];


    data.series.forEach((serie)=>{
        let date = new Date(serie.date)
        serie.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    })
    data.events.forEach((event)=>{
        let date = new Date(event.startdate)
        event.startdate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        okdatum = event.startdate.getTime();
    })

    data.series.forEach((serie)=>{
        if(first_date === null){
            first_date = serie.date
        }
        if(first_date>serie.date){
            first_date=serie.date
        }
        if(last_date === null){
            last_date = serie.date
        }
        if(last_date<serie.date){
            last_date=serie.date
        }
    })

    console.log({last_date})
    let running_date = first_date
    console.log(running_date)
    let t=0
    while(running_date<=last_date){

        let e = {
            date: running_date
        }

        data.series.forEach(serie=>{
            if(serie.date.getDate() === running_date.getDate() && serie.date.getMonth() === running_date.getMonth() && serie.date.getFullYear() === running_date.getFullYear()){
                e = serie
                new_series.push(e)
            }else{

            }
        })


        let day = running_date.getDate()
        let month = running_date.getMonth()
        let year = running_date.getFullYear()
        running_date = new Date(year, month, day + 1 )

        t++;
        if(t>365*50)
            break;
    }

    console.log({new_series})

    data.events.forEach((event)=>{
        let found = false
        console.log({event})
        data.series.forEach(serie=>{
            if(serie.date.getDate() === event.startdate.getDate() && serie.date.getMonth() === event.startdate.getMonth() && serie.date.getFullYear() === event.startdate.getFullYear()){
                found = true
            }
        })
        if(!found){
            console.log({startDate: event.startdate})
            new_series.push({date:event.startdate, BMI: null, TWL:null, percentiel25:null, percentiel50:null, percentiel75:null})
        }
    })
    console.log({new_series})

    new_series.sort((a,b)=>a.date-b.date)
    data.series = new_series
    console.log(data)

    data.series.forEach((serie)=>{
        delete serie['OK_datum'];
        serie.date = serie.date.getTime()
    })
    data.okdatum = okdatum;
    return data
}

const BmiTwl = () => {
    let [graphData, setGraphData] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    let host = searchParams.get('host');
    const practitioner_id = searchParams.get('practitioner_id');
    const patient_id = searchParams.get('patient_id');
    const observation_id = searchParams.get('observation_id');
    const service = searchParams.get('service');
    const [width, setWidth]   = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [ok_datum, setOk_datum] = "09-01-2023"
    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    console.log({host})
    let errorMessage = "";
    if(host === null){
        errorMessage+="<b>Host</b> parameter ontbreekt\n";
    }
    if(practitioner_id === null){
        errorMessage+="practitioner_id parameter ontbreekt\n";
    }
    if(patient_id === null){
        errorMessage+="patient_id parameter ontbreekt\n";
    }
    if(observation_id === null){
        errorMessage+="observation_id parameter ontbreekt\n";
    }
    if(service === null){
        errorMessage+="service parameter ontbreekt";
    }

    let port = "18088"
    //host = "10.249.13.81"
    if (host.toLowerCase() === "tim-tf-pro-03.hosted.local") {
        port = "80";
    }

    //host = host + ":" + port

    useEffect(() => {
        if(errorMessage==="") {
            let url = `https://${host}/charts/api?practitioner_id=${practitioner_id}&patient_id=${patient_id}&observation_id=${observation_id}&service=${service}`;
            console.log({url})
            fetch(url)
                .then(response => response.json())
                .then(data => setGraphData(processData2(data)))
        }

    },[host, practitioner_id, patient_id, observation_id])


    if(host===null || practitioner_id===null || patient_id===null || observation_id===null || service===null){

        return (
            <div style={{"padding": "10px"}}>
                {(host===null) && <p><b>host</b> parameter ontbreekt</p>}
                {(practitioner_id===null) && <p><b>practitioner_id</b> parameter ontbreekt</p>}
                {(patient_id===null) && <p><b>patient_id</b> parameter ontbreekt</p>}
                {(observation_id===null) && <p><b>observation_id</b> parameter ontbreekt</p>}
                {(service===null) && <p><b>service</b> parameter ontbreekt</p>}
            </div>
        )
    }

    let error = graphData.error
    if(error!==undefined){
        return (
            <div style={{"padding": "10px"}}>
                <p>{graphData.error}</p>
            </div>
                )
    }

    if(graphData.series===undefined){
        return (
            <div style={{"padding": "10px"}}>
                <p>{graphData}</p>
            </div>
        )
    }


    return (
        <ResponsiveContainer width={width-40} height={height-40} style={{"padding": "10px"}}>

            <ComposedChart
                width={width}
                height={height}
                data={graphData.series}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >

                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                        <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                    </linearGradient>
                    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                        <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                    </linearGradient>
                </defs>
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" domain={['auto', 'auto']}  scale="time"   type="number" tickFormatter={dateFormatter} interval="preserveStartEnd"/>
                <Tooltip
                    labelFormatter={value => {
                        return `${moment(new Date(value)).format('DD-MM-YYYY')}`;
                    }}
                />
                <Legend/>
                <Area type="monotone" connectNulls dataKey="BMI" stroke="#82ca9d" fillOpacity={1} fill="url(#colorUv)" />
                <Area type="monotone" connectNulls dataKey="TWL" stroke="#8884d8" fillOpacity={1} fill="url(#colorPv)" />

                <Line type="basis" dataKey="percentile75" stroke="#e075c5" dot={false} name="75th percentile"/>
                <Line type="basis" dataKey="percentile50" stroke="#c41a4d" dot={false} name="50th percentile"/>
                <Line type="basis" dataKey="percentile25" stroke="#9e0332" dot={false} name="25th percentile"/>


                <ReferenceLine x={graphData.okdatum} stroke="red" label={<ReferenceLabel date={`${moment(new Date(graphData.okdatum)).format('DD-MM-YYYY')}`} />}  />





            </ComposedChart>
        </ResponsiveContainer>
    );
};




export default BmiTwl;
